export default __webpack_public_path__ + "static/media/icon-3dots-vertical.af4485f3.svg";